import { render, staticRenderFns } from "./registro_exito.vue?vue&type=template&id=b5aa0750&scoped=true&"
import script from "./registro_exito.vue?vue&type=script&lang=js&"
export * from "./registro_exito.vue?vue&type=script&lang=js&"
import style0 from "./registro_exito.vue?vue&type=style&index=0&id=b5aa0750&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5aa0750",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/andres/repositories/merge/webapp/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VImg } from 'vuetify/lib'
installComponents(component, {VCardText,VFlex,VImg})
